export enum AKQJSymbolType {
  AKQJSymbolTypeA = 'A',
  AKQJSymbolTypeK = 'K',
  AKQJSymbolTypeQ = 'Q',
  AKQJSymbolTypeJ = 'J',
}

export enum MSymbolType {
  MSymbolTypeM1 = 'M1',
  MSymbolTypeM2 = 'M2',
  MSymbolTypeM3 = 'M3',
  MSymbolTypeM4 = 'M4',
  MSymbolTypeM5 = 'M5',
}

export enum BombSymbolType {
  BombSymbolTypeNormal = 'symbol_s1_explode',
  BombSymbolTypeAction = 'highlight',
}

export enum ScatterSymbolType {
  ScatterSymbolTypeIn = 'symbol_sc_in',
  ScatterSymbolTypePeek = 'symbol_sc_shine',
  ScatterSymbolTypeWin = 'symbol_sc_win',
  SuperScatterSymbolIn = 'symbol_gsc_in',
  SuperScatterSymbolPeek = 'symbol_gsc_shine',
  SuperScatterSymbolWin = 'symbol_gsc_win',
}

export enum BayType {
  BayTypeAction = 'action',
}

export enum MultiplierType {
  Multiple_1 = 'Multiple_1',
  Multiple_2 = 'Multiple_2',
  Multiple_3 = 'Multiple_3',
  Multiple_4 = 'Multiple_4',
  Multiple_5 = 'Multiple_5',
  Multiple_6 = 'Multiple_6',
  Multiple_7 = 'Multiple_7',
  Multiple_8 = 'Multiple_8',
  Multiple_9 = 'Multiple_9',
  Multiple_10 = 'Multiple_10',
  Multiple_11 = 'Multiple_11',
  Multiple_12 = 'Multiple_12',
  Multiple_13 = 'Multiple_13',
  Multiple_14 = 'Multiple_14',
  Multiple_15 = 'Multiple_15',
  Multiple_16 = 'Multiple_16',
  Multiple_17 = 'Multiple_17',
  Multiple_18 = 'Multiple_18',
}
export enum BackgroundType {
  BayTypeAction = 'action',
}
